import { Socket } from "socket.io-client";
import { PartiallyOptional } from "@/types/utils.types";

export interface ICustomInputResult {
  cpuTime?: string;
  description?: string;
  memoryUsage?: string;
  output?: string;
  runningTime?: string;
  status?: string;
  sid: string;
}

export interface TSingleTestCaseResult {
  id: number;
  name: string;
  status: string;
  description: string;
  output: string;
  weight: number;
  is_sample: boolean;
  log: string;
  running_time: string;
  memory_usage: string;
  cputime: string;
  input: string;
  expected_output: string;
  error_metrics: [];
  attachments: string[];
  annotation: string;
}

export type TSingleTestCase = PartiallyOptional<
  TSingleTestCaseResult,
  | "status"
  | "description"
  | "output"
  | "weight"
  | "is_sample"
  | "log"
  | "running_time"
  | "memory_usage"
  | "cputime"
  | "input"
  | "expected_output"
  | "error_metrics"
  | "attachments"
  | "annotation"
>;

export interface TProblemTestCaseResult {
  status: string;
  testCases: TSingleTestCaseResult[];
}

export enum ERunCodeType {
  CUSTOM_INPUT = "Custom Input",
  TESTCASES = "Test Cases",
}

export interface IRunCodeProps {
  code: string | undefined;
  expandRunCodeTabs: () => void;
  customInput: string;
  onChangeCustomInput: (value: string) => void;
  isTestCases: boolean;
  isATFProblem: boolean;
  isDatabaseQuestion: boolean;
  collab?: {
    enabled: true;
    socket: Socket;
  };
  isRunCodeInProcess: boolean;
  isAbortInProcess: boolean;
  customInputResult: ICustomInputResult | undefined;
  solutionSlug: string | undefined;
  testCaseResult: TProblemTestCaseResult | undefined;
  onRunCodeClick: (runCodeType: ERunCodeType) => void;
  onAbortClick: () => void;
}

export interface ICustomInputResultProps {
  customInputResult: ICustomInputResult;
  input: string;
  shouldShowRunAllTestCases: boolean;
  onRunAllTestCases: () => void;
}

export interface IRunCodeProgressProps {
  testCases: TSingleTestCaseResult[];
}

export interface ITestCaseResultProps {
  testCaseResults: TSingleTestCase[];
  isATFProblem: boolean;
}
